/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ControlFunctionOperationalScopeDTO model module.
 * @module model/ControlFunctionOperationalScopeDTO
 * @version v0
 */
export class ControlFunctionOperationalScopeDTO {
  /**
   * Constructs a new <code>ControlFunctionOperationalScopeDTO</code>.
   * @alias module:model/ControlFunctionOperationalScopeDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ControlFunctionOperationalScopeDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ControlFunctionOperationalScopeDTO} obj Optional instance to populate.
   * @return {module:model/ControlFunctionOperationalScopeDTO} The populated <code>ControlFunctionOperationalScopeDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ControlFunctionOperationalScopeDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ControlFunctionOperationalScopeDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
ControlFunctionOperationalScopeDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
ControlFunctionOperationalScopeDTO.prototype.active = undefined;

/**
 * @member {Number} position
 */
ControlFunctionOperationalScopeDTO.prototype.position = undefined;

/**
 * @member {String} tooltip
 */
 ControlFunctionOperationalScopeDTO.prototype.tooltip = undefined;
